import React, { FC } from 'react';
import './HowItWorksPill.css';

interface HowItWorksPillProps {
  onClick: () => void
}

const HowItWorksPill: FC<HowItWorksPillProps> = ({onClick}:HowItWorksPillProps) => {
  return (
    <div className="HowItWorksPill" onClick={onClick}>
      <div className="question-icon"/>
      <div className="how-text">How it Works</div>
    </div>
  )
};

export default HowItWorksPill;
